import React, { useState, useEffect, useRef } from "react";
import { Box, Container, Grid, Typography } from "@mui/material";
import "./Home.css";
import { images } from "../../config/images";
import WhoWeAre from "./WhoWeAre/WhoWeAre";
import OurSegment from "./OurSegment/OurSegment";
import AboutUsculture from "../../components/AboutUsCulture/AboutUsCulture";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { Link, useNavigate } from "react-router-dom";
import { slugify } from "../../utils/slugify";
import {
  aboutUsData,
  homeblog,
  ourbrand,
  setting,
  slider,
  whoweare,
} from "../../config/services";
import FullpageLoader from "../../Fullscreen/FullScreenLoader";

const Home = ({ settingAPIData, headerAPIData }) => {
  const [homeAPIData, setHomeAPIData] = useState([]);
  const [ourbrandAPIData, setOurBrandAPIData] = useState([]);
  const [sliderAPI, setSliderAPI] = useState([]);
  const [whoWeAreData, setWhoWeAreData] = useState([]);
  const [aboutUsAPIData, setAboutUsAPIData] = useState([]);
  const [homeLoading, setHomeLoading] = useState(false);
  const [brandLoading, setBrandLoading] = useState(false);
  const [sliderLoading, setSliderLoading] = useState(false);
  const [whoWeAreLoading, setWhoWeAreLoading] = useState(false);
  const [aboutUsLoading, setAboutUsLoading] = useState(false);

  const [activeSlide, setActiveSlide] = useState(0);
  const sliderRef = useRef(null);

  useEffect(() => {
    fetchSliderData();
    fetchHomeBlogData();
    fetchOurBrandData();
    fetchWhoweAreData();
    fetchAboutUsData();
  }, []);

  const fetchSliderData = async () => {
    try {
      setSliderLoading(true);
      const sliderResp = await slider();
      if (sliderResp.data.code === 200 || sliderResp.data.code === 201) {
        setSliderLoading(false);
        setSliderAPI(sliderResp.data.responseBody);
      }
    } catch (error) {
      setSliderLoading(false);
      console.error("Error fetching slider data", error);
    }
  };

  const fetchHomeBlogData = async () => {
    try {
      setHomeLoading(true);
      const homeBlogResp = await homeblog();
      if (homeBlogResp.data.code === 200 || homeBlogResp.data.code === 201) {
        setHomeAPIData(homeBlogResp.data.responseBody);
        setHomeLoading(false);
      }
    } catch (error) {
      setHomeLoading(false);
      console.error("Error fetching blogs data", error);
    }
  };

  const fetchOurBrandData = async () => {
    try {
      setBrandLoading(true);
      const ourBrandResp = await ourbrand();
      if (ourBrandResp.data.code === 200 || ourBrandResp.data.code === 201) {
        setOurBrandAPIData(ourBrandResp.data.responseBody);
        setBrandLoading(false);
      }
    } catch (error) {
      setBrandLoading(false);
      console.error("Error fetching brand data", error);
    }
  };

  const fetchWhoweAreData = async () => {
    try {
      setWhoWeAreLoading(true);
      const resp = await whoweare();
      if (resp.data.code === 200 || resp.data.code === 201) {
        setWhoWeAreData(resp.data.responseBody);
        setWhoWeAreLoading(false);
      }
    } catch (error) {
      setWhoWeAreLoading(false);
      console.log("handlesubmit", error);
    }
  };

  const fetchAboutUsData = async () => {
    try {
      setAboutUsLoading(true);
      const resp = await aboutUsData();
      if (resp.data.code == 200 || resp.data.code == 201) {
        setAboutUsAPIData(resp.data.responseBody);
        setAboutUsLoading(false);
      }
    } catch (error) {
      setAboutUsLoading(false);
      console.log("handlesubmit", error);
    }
  };

  const settings = {
    dots: false, // Disable dots
    infinite: true, // Enable infinite scrolling
    arrows: false,
    speed: 500, // Transition speed
    slidesToShow: 7, // Show 5 cards at once
    slidesToScroll: 1, // Scroll 1 card at a time
    autoplay: true, // Enable auto-scroll
    autoplaySpeed: 1000, // Set auto-scroll speed (e.g., 2000ms = 2 seconds)
    responsive: [
      {
        breakpoint: 1024, // For tablet screens
        settings: {
          slidesToShow: 4, // Show 4 cards on tablets
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768, // For smaller tablets
        settings: {
          slidesToShow: 2, // Show 2 cards on smaller screens
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480, // For mobile screens
        settings: {
          slidesToShow: 1, // Show 1 card on mobile
          slidesToScroll: 1,
        },
      },
    ],
  };

  const navigate = useNavigate();

  const sliderSettings = {
    dots: false, // Show dots for navigation
    infinite: true, // Enable infinite scrolling
    autoplay: true, // Enable automatic sliding
    autoplaySpeed: 5000, // Set slide duration to 5 seconds
    speed: 500, // Transition speed
    slidesToShow: 1, // Show one slide at a time
    slidesToScroll: 1, // Scroll one slide at a time
    arrows: false, // Disable navigation arrows
    beforeChange: (current, next) => setActiveSlide(next), // Update active slide index
  };

  const handleIndicatorClick = (index) => {
    if (sliderRef.current) {
      sliderRef.current.slickGoTo(index); // Navigate to selected slide
    }
  };

  const isPDF = (url) => url?.toLowerCase().endsWith(".pdf");

// After fully image loaded then remove shimmer 
  const [imagesLoaded, setImagesLoaded] = useState(false);

  useEffect(() => {
    if (sliderAPI.length > 0) {
      const imagePromises = sliderAPI.map((slide) => {
        return new Promise((resolve) => {
          const img = new Image();
          img.src = slide.image;
          img.onload = resolve;
          img.onerror = resolve; // Handle errors gracefully
        });
      });

      Promise.all(imagePromises).then(() => setImagesLoaded(true));
    }
  }, [sliderAPI]);

  return (
    <>
      <div className="container-fluid">
        <div id="healthcareSlider" className="carousel slide h-auto">
          <div className="carousel-indicators">
            {!sliderLoading && imagesLoaded ? (
              sliderAPI.map((_, index) => (
                <button
                  key={index}
                  type="button"
                  data-bs-target="#healthcareSlider"
                  className={activeSlide === index ? "active" : ""}
                  aria-label={`Slide ${index + 1}`}
                  onClick={() => handleIndicatorClick(index)}
                ></button>
              ))
            ) : (
              <div className="shimmer-indicators"></div>
            )}
          </div>

          {/* Carousel Items */}
          <div className="carousel-inner">
            {!sliderLoading && imagesLoaded ? (
              <Slider {...sliderSettings} key={sliderAPI.id} ref={sliderRef}>
                {sliderAPI?.map((slide, index) => (
                  <div key={index}>
                    <div className="slider-container">
                      <img
                        src={slide.image}
                        className="d-block slider-imges pb-0"
                        alt={`Slider Image ${index + 1}`}
                      />
                      <div className="slider-text">
                        <h1>{slide.title}</h1>
                        <Link
                          to={slide.button_redirection}
                          className="btn btn-custom slider-button"
                        >
                          {slide.button_text}
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </Slider>
            ) : (
              <div className="shimmer-slider">
                <div className="shimmer-box"></div>
              </div>
            )}
          </div>

          {/* Optional Left Logo */}
          <div className="left-logo">
            <img className="left-rag" src={images.image1} alt="Left Logo" />
          </div>
        </div>
      </div>

      <div className="home common-sec">
        <Grid
          container
          rowSpacing={1}
          columnSpacing={{ xs: 1, sm: 2, md: 20, lg: 10 }}
        >
          <Grid item xs={12} sm={12} md={7} lg={7}>
            <div>
              <img src={images.round} alt="" className="home-round" />
            </div>
            <div>
              <img src={images.rectangle} alt="" className="home-square" />
            </div>
          </Grid>
        </Grid>
      </div>

      <div className="section-padding"></div>

      <WhoWeAre whoWeAreData={whoWeAreData} whoWeAreLoading={whoWeAreLoading} />

      <AboutUsculture
        settingAPIDataChild={settingAPIData}
        headerAPIDataChild={headerAPIData}
        aboutUsAPIData={aboutUsAPIData}
        aboutUsLoading={aboutUsLoading}
      />
      <OurSegment
        settingAPIDataChild={settingAPIData}
        headerAPIDataChild={headerAPIData}
      />
      <section className="our-brands-section">
        <div className="our-brands-header">
          <h2 className="our-brands-title">Our Brands</h2>
        </div>
        <div className="our-brands-slider-wrap">
          <Slider {...settings} className="our-brands-slider">
            {!brandLoading
              ? ourbrandAPIData.map((logo, index) => (
                <div key={index} className="our-brands-card">
                  <div className="our-brands-card-inner">
                    <img
                      src={logo.image}
                      alt={logo.title || `Brand ${index + 1}`}
                      className="our-brands-card-img"
                    />
                  </div>
                </div>
              ))
              : Array.from({ length: 6 }).map((_, index) => (
                <div key={index} className="our-brands-card">
                  <div className="our-brands-card-inner our-brands-card-shimmer">
                    <div className="our-brands-shimmer-img" />
                  </div>
                </div>
              ))}
          </Slider>
        </div>
      </section>

      <section className="home-blogs-section">
        <div className="common-sec">
          <header className="home-blogs-header">
            <span className="home-blogs-badge">Blog & News</span>
            <h2 className="home-blogs-title">Our Latest Blogs & News</h2>
          </header>
          <Grid container spacing={2}>
            {!homeLoading
              ? homeAPIData.map((item, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={4}
                  className="mt-2"
                  key={item.id}
                >
                  <Box className="home-blog-card mt-4 mb-4">
                    <div className="home-blog-card-icon-wrap">
                      {isPDF(item.image) ? (
                        <img src={item.cover_image || images.pdfImg} alt="PDF" />
                      ) : (
                        <img
                          src={item.image}
                          alt={item.title || "Blog"}
                        />
                      )}
                    </div>
                    <div className="home-blog-card-body">
                      <div className="home-blog-card-meta">
                        <span className="home-blog-card-meta-item">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" /><circle cx="12" cy="7" r="4" /></svg>
                          {item.author_name}
                        </span>
                        <span className="home-blog-card-meta-sep" aria-hidden="true" />
                        <span className="home-blog-card-meta-item">
                          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="4" width="18" height="18" rx="2" ry="2" /><line x1="16" y1="2" x2="16" y2="6" /><line x1="8" y1="2" x2="8" y2="6" /><line x1="3" y1="10" x2="21" y2="10" /></svg>
                          {new Date(item.date).toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" })}
                        </span>
                      </div>
                      <h3 className="home-blog-card-title">{item.title}</h3>
                      <button
                        type="button"
                        className="home-blog-card-btn"
                        onClick={() => navigate(`/blog/${slugify(item.title)}`, { state: { blogId: item.id } })}
                      >
                        Read More <span className="home-blog-card-btn-arrow">→</span>
                      </button>
                    </div>
                  </Box>
                </Grid>
              ))
              : Array.from({ length: 3 }).map((_, index) => (
                <Grid
                  item
                  xs={12}
                  sm={6}
                  md={4}
                  lg={4}
                  className="mt-2"
                  key={index}
                >
                  <Box className="home-blog-card mt-4 shimmer-card">
                    <div className="home-blog-card-icon-wrap">
                      <div className="shimmer-img" />
                    </div>
                    <div className="home-blog-card-body">
                      <div className="home-blog-card-meta">
                        <div className="shimmer-contact-icon" />
                        <span className="shimmer-text" style={{ width: "80px" }} />
                        <span className="home-blog-card-meta-sep" />
                        <div className="shimmer-contact-icon" />
                        <span className="shimmer-text" style={{ width: "70px" }} />
                      </div>
                      <div className="shimmer-text shimmer-title" style={{ marginBottom: "16px" }} />
                      <div className="shimmer-button" style={{ width: "120px", height: "40px", borderRadius: "8px" }} />
                    </div>
                  </Box>
                </Grid>
              ))}
          </Grid>
        </div>
      </section>
    </>
  );
};

export default Home;
